import { environment } from '../../environment'
import { Equipment, Horse } from './class.modal'

export enum Mobility {
  INDEPENDENT = 'independent',
  ASSISTANCE_NEEDED = 'assistanceNeeded',
  UNAIDED = 'unaided',
  CRUTCHES = 'crutches',
  WALKING_STICK = 'walkingStick',
  WALKER = 'walker',
  WHEELCHAIR = 'wheelchair',
  OTHERS = 'others'
}

export enum Disability {
  AUTISM_SPECTRUM_DISORDERS = 'autismSpectrumDisorders',
  ATTENTION_DEFICIT_AND_HYPERACTIVITY_DISORDER = 'attentionDeficitAndHyperactivityDisorder',
  SPECIFIC_LEARNING_DIFFICULTIES = 'specificLearningDifficulties',
  INTELLECTUAL_DISABILITY = 'intellectualDisability',
  COMMUNICATION_DIFFICULTIES = 'communicationDifficulties',
  VISUAL_IMPAIRMENT = 'visualImpairment',
  HEARING_IMPAIRMENT = 'hearingImpairment',
  BEHAVIORAL_AND_EMOTIONAL_DIFFICULTIES = 'behavioralAndEmotionalDifficulties',
  PHYSICAL_DISABILITY = 'physicalDisability',
  OTHERS = 'others'
}

export interface User {
  id?: number
  // volunteer | xx_coach
  type?: string
  email?: string
  name_en?: string
  name_zh_cn?: string
  name_zh_hk?: string
  birth?: string
  mobile?: string
  emergency_name?: string
  emergency_mobile?: string
  created_at?: string | Date
  gender?: string
  grade?: string
}

export interface Person {
  id?: number
  name?: {
    enName?: string
    cnName?: string
  }
  weight?: string
  height?: string
  gender?: 'male' | 'female'
  birthDate?: Date
  headSize?: string
  age?: number

  ageOrCalc?(): number
}

export interface Diagnosis {
  diagnosisStr?: string
  disabilities?: Disability[]
  otherDisabilities?: string
  mobility?: Mobility
  otherMobility?: string
}

export interface Rider extends Person {
  photo?: string
  physicalAbility?: string[]
  medication?: string
  diagnosis?: Diagnosis
  physicalDisabilities?: string
  physicalDisabilitiesOther?: string
  mentalDisabilities?: string
  mentalDisabilitiesOther?: string
  ridingExperience?: string
  nationality?: string
  language?: string
  agreeTakePhoto?: boolean
  isAttendance?: string
  leaveRequests?: LeaveRequest[]
  assignedVolunteers?: {
    leader?: Person
    helper?: Person
  }
  assignedHorse?: Horse
  assignedEquipment?: Equipment
  assignedTasks?: string[]
  school?: {
    name?: string
  }

  canWalk?(): boolean
}

export interface Volunteer extends Person {
  isCoach?: boolean
  isAttendance?: string
}

export interface LeaveRequest {
  type: 'casual' | 'sick'
  status: 'pending' | 'approved'
}

export abstract class AbstractRider implements Rider {
  id?: number
  name?: {
    enName?: string
    cnName?: string
  }
  photo?: string
  weight?: string
  height?: string
  gender?: 'male' | 'female'
  birthDate?: Date
  headSize?: string
  age?: number
  term?: string
  termYear?: string
  physicalAbility?: string[]
  medication?: string
  diagnosis?: Diagnosis
  physicalDisabilities?: string
  physicalDisabilitiesOther?: string
  mentalDisabilities?: string
  mentalDisabilitiesOther?: string
  ridingExperience?: string
  nationality?: string
  language?: string
  agreeTakePhoto?: boolean
  isAttendance?: string
  leaveRequests?: LeaveRequest[]
  assignedVolunteers?: {
    leader?: Person
    helper?: Person
  }
  assignedHorse?: Horse
  assignedEquipment?: Equipment
  assignedTasks?: string[]
  school?: {
    name?: string
  }

  constructor(rider: Rider) {
    Object.assign(this, rider)
  }

  abstract ageOrCalc(): number
  abstract canWalk(): boolean
  abstract photoUrl(): string
}

export class RiderImpl extends AbstractRider {
  ageOrCalc() {
    if (this.age) {
      return this.age
    }
    return this.birthDate?.getFullYear() ?? 0
  }

  canWalk() {
    if (this.diagnosis?.mobility === Mobility.WHEELCHAIR) {
      return false
    }
    return true
  }

  photoUrl(): string {
    if (!this.photo) {
      return ''
    }

    return environment.baseUrl + '/storage/' + this.photo
  }
}
